<div class="toast-container">
	@if (toastService.toast().length > 0) {
		<div @bounceInOutDesktop class="toast-message desktop">{{ toastService.toast() }}</div>
		<div @bounceInOutMobile class="toast-message mobile">{{ toastService.toast() }}</div>
	}
</div>
